export default {
  'about.header': 'About Us',
  'about.update': 'Last updated on',
};
